import React, { useEffect, useMemo, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import MonthlyOrdersTableBySubscriptionView from "./MonthlyOrdersTableBySubscriptionView";

export default function SubscriptionDetailsModal({
    isOpen,
    onClose,
    customerEmail,
    orders,
    filters,
    filterOrders,
    sortedOrders,
    setSortConfig,
    onRefresh,
}) {
    const [expandedLocation, setExpandedLocation] = useState(null);
    const [hideZeroEnabled, setHideZeroEnabled] = useState(true);

    const filteredOrders = useMemo(() => {
        if (!customerEmail) return [];
        return orders.map((loc) => ({
            ...loc,
            subscriptions: (loc.subscriptions || []).filter(
                (s) =>
                    s.customer_email &&
                    s.customer_email.toLowerCase() === customerEmail.toLowerCase()
            ),
        }));
    }, [orders, customerEmail]);

    // Auto expand first location and auto-enable "Hide Zero Subs"
    useEffect(() => {
        if (filteredOrders.length > 0) {
            setHideZeroEnabled(true);
            setExpandedLocation(filteredOrders[0].id);
        }
    }, [filteredOrders]);

    return (
        <Modal isOpen={isOpen} toggle={onClose} size="xl">
            <ModalHeader toggle={onClose}>Subscriptions for {customerEmail}</ModalHeader>
            <ModalBody style={{ maxHeight: "80vh", overflowY: "auto" }}>
                <MonthlyOrdersTableBySubscriptionView
                    orders={filteredOrders}
                    search=""
                    filters={filters}
                    filterOrders={filterOrders}
                    expandedLocation={expandedLocation}
                    setExpandedLocation={setExpandedLocation}
                    locationPages={{}}
                    setLocationPages={() => { }}
                    pageSize={5}
                    setSortConfig={setSortConfig}
                    sortedOrders={sortedOrders}
                    onRefresh={onRefresh}
                    forceHideZero={hideZeroEnabled}
                />
            </ModalBody>
        </Modal>
    );
}